import{iterate}from"wild-wild-path";

import{validateFunction}from"./validate.js";


export const find=(
target,
query,
condition,
{
childFirst,
roots,
leaves,
sort,
entries,
shallowArrays,
classes,
inherited
}={})=>

{
validateFunction(condition);


for(const entry of iterate(target,query,{
childFirst,
roots,
leaves,
sort,
missing:false,
entries,
shallowArrays,
classes,
inherited
})){

if(condition(entry)){
return entry
}
}
};